class FacetRemove extends HTMLElement {
  connectedCallback () {
    this.setupListeners()
  }

  setupListeners () {
    this.addEventListener('click', this.handleClick.bind(this))
  }

  handleClick (event) {
    window.theme.results.eventBus.publish(window.theme.results.events.UI.FACET_REMOVED, {
      field: this.getAttribute('data-filter-label'),
      value: [this.getAttribute('data-filter-value')],
    })
  }

  /**
   * @returns {CollectionFilters|null}
   */
  get filters () {
    return this.closest('collection-filters')
  }
}

if (!customElements.get('facet-remove')) {
  customElements.define('facet-remove', FacetRemove)
}
